export default __webpack_public_path__ + "static/media/logo-sm.0a3bb6a6.png";